import { AppError, EAppErrorKind } from '@/utils/error';
import { request } from '@/utils/request';
import axios from 'axios';

interface IGetUploadUrlPayload {
  file: File;
  fileName?: string;
  onProgress?: (progress: number) => void;
  urlType?: 'BASE_MAP' | 'AVATAR';
}

export const getUploadUrl = async (payload: IGetUploadUrlPayload) => {
  const { file, fileName, onProgress, urlType } = payload;
  const res = await request.get<{ url: string; key: string }>(
    `/upload-url?fileName=${fileName || file.name}&urlType=${urlType || 'BASE_MAP'}`
  );
  if (!res.data.data.url) {
    throw new AppError(EAppErrorKind.FILE_UPLOAD_FAILED);
  }
  const uploadResult = await uploadFile({ url: res.data.data.url, file, onProgress });
  return {
    uploadResult,
    key: res.data.data.key,
    url: res.data.data.url
  };
};

interface IUploadFileParams {
  url: string;
  file: File | Blob | ArrayBuffer;
  onProgress?: (progress: number) => void;
  contentType?: string;
}

export const uploadFile = async ({ url, file, onProgress, contentType }: IUploadFileParams) => {
  let type = 'application/octet-stream';
  if (file instanceof File) {
    type = file.type || 'application/octet-stream';
  } else if (contentType) {
    type = contentType;
  }

  return axios.put(url, file, {
    headers: {
      'Content-Type': type
    },
    timeout: 0,
    withCredentials: false,
    onUploadProgress(progressEvent) {
      const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
      onProgress?.(progress);
    }
  });
};
